module.exports = __webpack_public_path__ + "img/element-25.46338b61.svg";